import Task from './Task';
import { createError } from '../error';

class ChangeUserDataSyncWindowTask extends Task {
  constructor($q, APIService, StaffUserService) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.StaffUserService = StaffUserService;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set staffUserId(id) {
    this._staffUserId = id;
  }

  get staffUserId() {
    return this._staffUserId;
  }

  set dataSyncWindowName(dataSyncWindowName) {
    this._dataSyncWindowName = dataSyncWindowName;
  }

  get dataSyncWindowName() {
    return this._dataSyncWindowName;
  }

  /**
   * Public methods
   */

  populate(data) {
    this.staffUserId = data.staffUserId;
    this.dataSyncWindowName = data.dataSyncWindowName;
  }

  serialize() {
    return {
      staffUserId: this.staffUserId,
      dataSyncWindowName: this.dataSyncWindowName,
    };
  }

  execute() {
    return this.StaffUserService.changeUserDataSyncWindow(this.staffUserId, this.dataSyncWindowName);
  }
}

export default ChangeUserDataSyncWindowTask;
